import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchZonesList = () => apiActionCreator({
  'endpoint': '/pickingZones',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ZONES_LIST,
    ActionTypes.FETCHED_ZONES_LIST,
    [
      ActionTypes.FETCHED_ZONES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchZone = (code) => apiActionCreator({
  'endpoint': `/pickingZones/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ZONE,
    ActionTypes.FETCHED_ZONE,
    [
      ActionTypes.FETCHED_ZONE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addZone = (data) => apiActionCreator({
  'endpoint': '/pickingZones',
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_ZONE,
    [
      ActionTypes.ADDED_ZONE,
      MessageActions.addMessageBoxInfo('Zona añadida satisfactoriamente'),
    ],
    [
      ActionTypes.ADDED_ZONE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const editZone = (code, data) =>
  apiActionCreator({
    'endpoint': `/pickingZones/${code}`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_ZONE,
      [
        ActionTypes.SAVED_ZONE,
        MessageActions.addMessageBoxInfo('Zona actualizada satisfactoriamente'),
      ],
      [ActionTypes.SAVED_ZONE_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const filterZones = (value) => ({
  'type': ActionTypes.FILTER_ZONES,
  'payload': value,
});

export const changeZonesTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_ZONES_TEXT_FILTER,
  'payload': value,
});

export const changeAssignedLocations = (value) => ({
  'type': ActionTypes.CHANGE_ASSIGNED_LOCATIONS,
  'payload': value,
});
